import { reloadWithCalculationFlash } from "../reload_with_flash";

const SUCCESS_MESSAGE = "Your calculation was successfully finished.";

const isScoresPage = () =>
  window.location.href.includes(`/leagues/${gon.league_id}/scores`);

const isHandicapsPage = () => window.location.href.includes("/handicaps");

const isSwalOpen = () =>
  Boolean(window.stopCalculationAutoReload) ||
  (typeof Swal !== "undefined" && Swal.isVisible());

export default class CompletionHandler {
  constructor() {
    this.notified = false;
  }

  reset() {
    this.notified = false;
  }

  handle(status) {
    if (!status.fullyComplete || this.notified) return;

    this.notified = true;

    if (this.canAutoReload(status)) {
      reloadWithCalculationFlash();
      return;
    }

    toastr.success(SUCCESS_MESSAGE);
  }

  canAutoReload(status) {
    if (!status.fullyComplete || isSwalOpen()) return false;
    if (status.hasNextRoundAsPosition) return false;

    return isScoresPage() || isHandicapsPage();
  }
}
